var _defs, _path, _path2, _path3, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2728",
    "data-name": "Group 2728",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208.746,
    height: 70.343,
    viewBox: "0 0 208.746 70.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14b8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.093,
    stopColor: "#14b8e1",
    stopOpacity: 0.961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#14b8e1",
    stopOpacity: 0.847
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442,
    stopColor: "#14b8e1",
    stopOpacity: 0.667
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#14b8e1",
    stopOpacity: 0.416
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#14b8e1",
    stopOpacity: 0.098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14b8e1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.234,
    y1: -0.523,
    x2: 1.004,
    y2: 1.632,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14b8e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.064,
    stopColor: "#14b8e1",
    stopOpacity: 0.969
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.158,
    stopColor: "#14b8e1",
    stopOpacity: 0.882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#14b8e1",
    stopOpacity: 0.737
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#14b8e1",
    stopOpacity: 0.537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#14b8e1",
    stopOpacity: 0.286
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#14b8e1",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14855",
    "data-name": "Path 14855",
    d: "M141.609,498.111v36.051l45.464,12.782V476.6Z",
    transform: "translate(-139.655 -476.601)",
    opacity: 0.5,
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14856",
    "data-name": "Path 14856",
    d: "M168.833,551.057H141.609l32.961,13.53,15.829-7.54Z",
    transform: "translate(-139.655 -494.532)",
    opacity: 0.5,
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14857",
    "data-name": "Path 14857",
    d: "M157.233,500.469v43.41l-18.2-3.969V503.859Z",
    transform: "translate(-139.035 -482.349)",
    fill: "#14b8e1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2724",
    "data-name": "Group 2724",
    transform: "translate(41.332 21.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2723",
    "data-name": "Group 2723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14858",
    "data-name": "Path 14858",
    d: "M205.6,540.214l-12.123-34.181H205.2l6.856,22.853h.2l6.905-22.853h11.228L218.32,540.214Z",
    transform: "translate(-193.478 -505.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14859",
    "data-name": "Path 14859",
    d: "M248.777,540.214V506.033h10.98v34.181Z",
    transform: "translate(-206.795 -505.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14860",
    "data-name": "Path 14860",
    d: "M298.231,507.906a8.933,8.933,0,0,1,4.322,7.875v.6H292.269v-.2a3.22,3.22,0,0,0-1.093-2.484,4.821,4.821,0,0,0-3.329-.994,7.046,7.046,0,0,0-3.354.646,1.86,1.86,0,0,0-1.167,1.589,2.13,2.13,0,0,0,1.59,1.988,30.6,30.6,0,0,0,5.117,1.341,55.427,55.427,0,0,1,6.782,1.764,11.559,11.559,0,0,1,4.645,3.006A8.046,8.046,0,0,1,303.5,528.7q0,6.063-4.1,8.992t-10.955,2.931q-8,0-12.445-2.683t-4.446-9.489h10.383q0,2.584,1.342,3.453a7.826,7.826,0,0,0,4.173.87,11.292,11.292,0,0,0,3.453-.447,1.789,1.789,0,0,0,1.367-1.839,2.023,2.023,0,0,0-1.516-1.863,30.281,30.281,0,0,0-4.943-1.316,56.81,56.81,0,0,1-6.906-1.863,11.652,11.652,0,0,1-4.769-3.2,8.657,8.657,0,0,1-2.037-6.061q0-5.614,4.347-8.272a20.8,20.8,0,0,1,11.005-2.658A19.934,19.934,0,0,1,298.231,507.906Z",
    transform: "translate(-212.28 -505.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14861",
    "data-name": "Path 14861",
    d: "M321.482,540.214V506.033h10.98v34.181Z",
    transform: "translate(-224.305 -505.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14862",
    "data-name": "Path 14862",
    d: "M365.155,514.776v25.438h-10.98V514.776H342.947v-8.743h33.387v8.743Z",
    transform: "translate(-229.474 -505.437)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2725",
    "data-name": "Group 2725",
    transform: "translate(18.198 22.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14863",
    "data-name": "Path 14863",
    d: "M163.006,540.214V506.032h10.98v34.182Z",
    transform: "translate(-163.006 -506.032)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2727",
    "data-name": "Group 2727",
    transform: "translate(191.91 22.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2726",
    "data-name": "Group 2726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14864",
    "data-name": "Path 14864",
    d: "M394.871,514.767v-7.8h-3.048v-.936h7.085v.936H395.86v7.8Z",
    transform: "translate(-391.823 -506.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14865",
    "data-name": "Path 14865",
    d: "M402.807,514.767v-8.734h1.148l3.127,4.142,3.075-4.142H411.3v8.734h-.99v-7.231l-3.233,4.156-3.286-4.156v7.231Z",
    transform: "translate(-394.468 -506.033)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.d39f0bbdacb3bb6ca3491c2a0d49411e.svg";
export { ForwardRef as ReactComponent };